import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { ProductPreview } from "../../../domain/projections/ProductPreview";
import { ProductRepositoryImpl } from "../../domain/productRepositoryImpl/ProductRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";

const productRepo = ProductRepositoryImpl.getInstance();

const useGetOtherLookProducts = (lookId: string, variantId: string) => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const { isLoading, data } = useQuery(
    {
      queryKey: ["useGetOtherLookProducts", auth, variantId, lookId],
      queryFn: async () => {
        return await productRepo.getOtherLookProducts(lookId, variantId, auth, apiUrl);
      },
      enabled: Boolean(auth) && Boolean(variantId) && Boolean(lookId),
    },
    queryClient,
  );

  return { isLoading, products: data || ([] as ProductPreview[]) };
};

export { useGetOtherLookProducts };
